import { render, staticRenderFns } from "./correctRate.vue?vue&type=template&id=d61b00a4&scoped=true&"
import script from "./correctRate.vue?vue&type=script&lang=js&"
export * from "./correctRate.vue?vue&type=script&lang=js&"
import style0 from "./correctRate.vue?vue&type=style&index=0&id=d61b00a4&prod&scoped=true&lang=scss&"
import style1 from "./correctRate.vue?vue&type=style&index=1&id=d61b00a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61b00a4",
  null
  
)

export default component.exports